import type { LalSegmentsListFilters } from '@openx/components-segment/types';
import type { ByPhraseFilter, ByValueFilter } from '@openx/components-table/serverSideCriteriaProcessing';
import { expiringSoonStatus } from '@openx/types/segments';
import type { AllTableCriteria } from '@openx/types/tableCriteria';
import { addDays } from 'date-fns';
import omit from 'lodash/omit';

export const adjustCriteriaFilters = (criteria: AllTableCriteria<LalSegmentsListFilters>) => {
  const hasExpiringSoonStatus = criteria.filters?.status?.includes?.(expiringSoonStatus);
  const now = new Date();
  now.setSeconds(0, 0);
  const initialByValue: ByValueFilter = hasExpiringSoonStatus
    ? [{ field: 'derived_expiry_date', values: [now.toISOString(), addDays(now, 10).toISOString()] }]
    : [];

  const byValue: ByValueFilter = Object.entries(omit(criteria.filters, 'phrase')).reduce((acc, [field, values]) => {
    if (values) {
      acc.push({
        field,
        values: values.split(',').filter(status => !!status && status !== expiringSoonStatus),
      });
    }

    return acc;
  }, initialByValue);

  const byPhrase: ByPhraseFilter = {
    fields: ['lookalike_name'],
    phrase: criteria.filters?.phrase ?? '',
  };

  return { byPhrase, byValue };
};
